<template>
  <div>
    <div class="box dis-none" id="quanjing">
      <!-- <button class="layui-btn layui-btn-normal layui-btn-xs btn" onclick="viewChange(0)">切换图片</button> -->
      <div id="container"></div>
      <div id="controller" class="hide">
        <i class="con forward-con" id="forw"></i>
        <i class="con back-con" id="back"></i>
        <i class="con left-con" id="left"></i>
        <i class="con right-con" id="right"></i>
      </div>
    </div>
    <div id="img" class="di-none-ov">
      <!-- <button class="layui-btn layui-btn-normal layui-btn-xs btn" onclick="viewChange(1)">切换全景</button> -->
      <img class="height100" src />
    </div>
    <div id="video" class="di-none-ov">
      <video id="videoo" height="100%" width="100%" controls autoplay="autoplay"
        poster="Content/js/PhotoSphereViewer/timg.gif">
        <source src type />
      </video>
    </div>
    <!-- 全景链接 -->
    <div id="pdf" class="dis-none">
      <!-- <a href id="pdfa"></a> -->
      <iframe id="pdfa" src frameborder="0" width="100%" height="100%"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jsonData2: ""
    };
  },
  props: {
    jsonData: ""
  },
  watch: {
    jsonData: {
      handler(val) {
        var _this = this;

        //清除
        $("#quanjing").hide();
        $("#pdf").hide();
        $("#img").hide();
        $("#video").hide();
        try {
          this.jsonData2 = JSON.parse(val);
          var data = this.jsonData2;
          console.log(data, 6666);

          if (data.lbst03 == 1 && data.mobl07 == 0) {
            $("#img").show();
            $("#img")
              .find("img")
              .attr("src", _this.$store.state.baseUrl + data.mobl08);
          } else if (data.lbst03 == 2) {
            $("#pdf").show();
            $("#pdfa").attr("src", data.mobl08);
            // document.getElementById("pdfa").click();
          } else if (data.lbst03 == 3) {
            var docType = data.mobl08.split(".")[1].toLowerCase();
            $("#video").show();
            var vid = document.getElementById("videoo");
            vid.src = _this.$store.state.baseUrl + data.mobl08;
            vid.play();
          } else if (data.lbst03 == 1 && data.mobl07 == 1) {
            $("#quanjing").show();
            var div = document.getElementById("container"),
              wheel = document.getElementById("controller"),
              isHold = false,
              PSVr,
              time,
              anim,
              PSV,
              tar;

            init();

            function init() {

              PSV = new PhotoSphereViewer({
                //   全景图路径
                panorama: _this.$store.state.baseUrl + data.mobl08,
                container: div,
                time_anim: false,
                navbar: true,
                size: {
                  width: "100%",
                  height: "100%"
                },
                tilt_down_max: Math.PI / 7,
                tilt_up_max: Math.PI / 7,
                onready: showController
              });
            }

            function showController() {
              bindEvent();
              wheel.className = "";
            }

            function bindEvent() {
              wheel.addEventListener("mousedown", isHoldDown, false);
              wheel.addEventListener("mouseup", holdUp, false);
            }

            function isHoldDown(e) {
              var startT, endT;

              tar = e.target;
              startT = new Date().getTime();

              time = setInterval(function () {
                endT = new Date().getTime();
                if (endT - startT > 1000 && isHold) {
                  hold();
                  clearInterval(time);
                } else if (!isHold) {
                  handleChange();
                  isHold = true;
                }
              }, 100);
            }

            function hold() {
              handleChange();
              anim = requestAnimationFrame(hold);
            }

            function handleChange() {
              var id = tar.getAttribute("id"),
                posi = PSV.getPosition();

              switch (id) {
                case "forw":
                  goStraight(posi);
                  break;
                case "back":
                  goBack(posi);
                  break;
                case "left":
                  turnLeft(posi);
                  break;
                case "right":
                  turnRight(posi);
                  break;
              }
            }

            window.addEventListener(
              "deviceorientation",
              DeviceOrientationHandler,
              false
            );

            function DeviceOrientationHandler(e) {
              //(e);
              var alpha = e.alpha,
                beta = e.beta,
                gamma = e.gamma;
              //(alpha + " " + beta + " " + gamma);
            }

            function holdUp() {
              clearInterval(time);
              cancelAnimationFrame(anim);
              isHold = false;
            }

            function goStraight(posi) {
              PSV.zoomIn();
              // //('forw');
            }

            function goBack(posi) {
              PSV.zoomOut();
              // //('back');
            }

            function turnLeft(posi) {
              PSV.moveTo(posi.longitude + 1, posi.latitude);
              // //(posi.long  + ' ' + (posi.long + 1));
            }

            function turnRight(posi) {
              PSV.moveTo(posi.longitude - 1, posi.latitude);
              // //(newLong);
            }
          }
        } catch (error) { }
      },
      deep: true
    }
  }
  // created() {
  //   this.jsonData = JSON.parse(this.jsonData);
  //   localStorage.removeItem("jsonData");
  // }
  // mounted() {
  //   var data = this.jsonData;
  //   if (data.lbst03 == 1 && data.mobl07 == 0) {
  //     $("#img").show();
  //     $("#img")
  //       .find("img")
  //       .attr("src", localStorage.url + data.mobl08);
  //   } else if (data.lbst03 == 2) {
  //     $("#pdf").show();
  //     $("#pdfa").attr("href", data.mobl08);
  //     document.getElementById("pdfa").click();
  //   } else if (data.lbst03 == 3) {
  //     var docType = data.mobl08.split(".")[1].toLowerCase();
  //     $("#video").show();
  //     $("#video")
  //       .find("source")
  //       .attr("src", localStorage.url + data.mobl08);
  //     $("#video")
  //       .find("source")
  //       .attr("type", "video/" + docType);
  //   } else if (data.lbst03 == 1 && data.mobl07 == 1) {
  //     $("#quanjing").show();
  //     var div = document.getElementById("container"),
  //       wheel = document.getElementById("controller"),
  //       isHold = false,
  //       PSVr,
  //       time,
  //       anim,
  //       PSV,
  //       tar;

  //     init();

  //     function init() {
  //       PSV = new PhotoSphereViewer({
  //         //   全景图路径
  //         panorama: localStorage.url + data.mobl08,
  //         container: div,
  //         time_anim: false,
  //         navbar: true,
  //         size: {
  //           width: "100%",
  //           height: "500px"
  //         },
  //         tilt_down_max: Math.PI / 7,
  //         tilt_up_max: Math.PI / 7,
  //         onready: showController
  //       });
  //       // //(PSV);
  //     }

  //     function showController() {
  //       bindEvent();
  //       wheel.className = "";
  //     }

  //     function bindEvent() {
  //       wheel.addEventListener("mousedown", isHoldDown, false);
  //       wheel.addEventListener("mouseup", holdUp, false);
  //     }

  //     function isHoldDown(e) {
  //       var startT, endT;

  //       tar = e.target;
  //       startT = new Date().getTime();

  //       time = setInterval(function() {
  //         endT = new Date().getTime();
  //         if (endT - startT > 1000 && isHold) {
  //           hold();
  //           clearInterval(time);
  //         } else if (!isHold) {
  //           handleChange();
  //           isHold = true;
  //         }
  //       }, 100);
  //     }

  //     function hold() {
  //       handleChange();
  //       anim = requestAnimationFrame(hold);
  //     }

  //     function handleChange() {
  //       var id = tar.getAttribute("id"),
  //         posi = PSV.getPosition();
  //       // //(posi)

  //       switch (id) {
  //         case "forw":
  //           goStraight(posi);
  //           break;
  //         case "back":
  //           goBack(posi);
  //           break;
  //         case "left":
  //           turnLeft(posi);
  //           break;
  //         case "right":
  //           turnRight(posi);
  //           break;
  //       }
  //     }

  //     window.addEventListener(
  //       "deviceorientation",
  //       DeviceOrientationHandler,
  //       false
  //     );

  //     function DeviceOrientationHandler(e) {
  //       //(e);
  //       var alpha = e.alpha,
  //         beta = e.beta,
  //         gamma = e.gamma;
  //       //(alpha + " " + beta + " " + gamma);
  //     }

  //     function holdUp() {
  //       clearInterval(time);
  //       cancelAnimationFrame(anim);
  //       isHold = false;
  //     }

  //     function goStraight(posi) {
  //       PSV.zoomIn();
  //       // //('forw');
  //     }

  //     function goBack(posi) {
  //       PSV.zoomOut();
  //       // //('back');
  //     }

  //     function turnLeft(posi) {
  //       PSV.moveTo(posi.longitude + 1, posi.latitude);
  //       // //(posi.long  + ' ' + (posi.long + 1));
  //     }

  //     function turnRight(posi) {
  //       PSV.moveTo(posi.longitude - 1, posi.latitude);
  //       // //(newLong);
  //     }
  //   }
  // }
};
</script>
<style lang="less" scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
  /*border: 1px solid #ff7667;*/
}

#controller {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  width: 190px;
  height: 190px;
  margin: auto;
  display: none;
}

#controller .con {
  position: absolute;
  width: 60px;
  height: 60px;
  background: url("/Content/js/PhotoSphereViewer/bottom_arrow.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
}

.con.forward-con {
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  -webkit-transform: rotate3d(0, 0, 1, 180deg);
  transform: rotate3d(0, 0, 1, 180deg);
}

.con.back-con {
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.con.left-con {
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  -webkit-transform: rotate3d(0, 0, 1, 90deg);
  transform: rotate3d(0, 0, 1, 90deg);
}

.con.right-con {
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  -webkit-transform: rotate3d(0, 0, 1, -90deg);
  transform: rotate3d(0, 0, 1, -90deg);
}

.hide {
  visibility: hidden !important;
}

.btn {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
}

/deep/ iframe {
  height: 100%;
  width: 100%;
}
</style>
<style scoped>
/* 新增 */
.dis-none {
  display: none;
  width: 100%;
  height: 100%;
}

.di-none-ov {
  display: none;
  overflow: auto;
  height: 100%;
  width: 100%;
}

.height100 {
  width: 100%;
  height: 100%;
}
</style>
